import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callMetaDataGetApi = async () => {
  const { data = {} } = await axiosInstanceClient.get(API.metadata);
  return data;
};